import moment from "moment";
import { useSelector } from "react-redux";

const InvoiceBasicDetails = ({ item }) => {

  // Since we removed workspace slice, provide a fallback
const workspaceInfo = {
  default_workspace: {
    name: "School"
  }
};
  const { default_workspace } = workspaceInfo;
 
  const vendorData = [
    {
      label: "Bill From",
      value: item?.vendor?.data,
      address: item?.vendorAddress?.data,
    },
    {
      label: "Bill To ",
      value: default_workspace?.name,
      address: default_workspace?.address,
    },
  ];

  const details = [
    { label: "PO Number", value: item?.purchaseOrder?.code },
    { label: "Invoice Date", value: moment(item.created_at).format("DD MMM YYYY")} ,
    { label: "Due Date", value: moment(item.due_date).format("DD MMM YYYY")},
  ];
  return (
    <div className="flex flex-col gap-2">
      <div className="grid grid-cols-2 ">
        {vendorData.map((item, index) => {
          return (
            <div key={index} className="flex flex-col font-medium">
              <span className="text-gray-600">{item.label}</span>
              <span className="text-theme font-bold flex flex-col gap-0 leading-none">
                <span>{item.value}</span>
                {item.address}
              </span>
            </div>
          );
        })}
      </div>
      <div>
      {details.map((item, index) => {
        return (
          <div
            key={index}
            className="flex flex-row items-center gap-2 font-medium"
          >
            <span className="text-gray-600">{item.label}</span>
            <span className="text-theme font-bold flex flex-col gap-0 leading-none">
              <span>{item.value}</span>
            </span>
          </div>
        );
      })}
      </div>
    </div>
  );
};
export default InvoiceBasicDetails;
